import BillingDetails from "../models/BillingDetails";
import { useAuthenticationStore } from "../state/modules/authentication";
import { useMainStore } from "../state/store";
import { useCurrencyStore } from "../state/modules/currency";
import { useRepo } from "pinia-orm";

export function getCurrencyForCountry(country) {
    var sign, name, icon;
    switch (country) {
        case "AU":
            sign = "$";
            name = "AUD";
            icon = "dollar-symbol";
            break;
        case "GB":
            sign = "£";
            name = "GBP";
            icon = "pound-symbol";
            break;
        default:
            sign = "€";
            name = "EUR";
            icon = "euro-symbol";
            break;
    }
    return {
        sign: sign,
        name: name,
        icon: icon
    };
}

export function getSymbol() {
    let data = getData();
    if (data.symbol && data.symbol.length > 0) {
        return data.symbol;
    }
    let billingDetails = useRepo(BillingDetails)
        .where("company_id", data.companyId)
        .first();
    let symbol = billingDetails
        ? getCurrencyForCountry(billingDetails.country)
        : getCurrencyForCountry(data["defaultRegion"]);
    mutate(symbol);
    return symbol;
}

export function fetchSymbol() {
    getSymbol();
}

export function clearSymbol() {
    mutate("");
}

function mutate(symbol) {
    stores().currencyStore.setSymbol(symbol);
}

function getData() {
    let data = {};
    data["symbol"] = stores().currencyStore.symbol;
    data["companyId"] = stores().authStore.currentCompanyId;
    data["defaultRegion"] = stores().mainStore.currentCompany.region;
    return data;
}

function stores() {
    return {
        mainStore: useMainStore(),
        currencyStore: useCurrencyStore(),
        authStore: useAuthenticationStore()
    };
}
